<script setup>
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import { validateInboxAvatarFile } from 'dashboard/helper/inboxAvatarUpload';

defineProps({
  logoPreview: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['logoSelected', 'remove']);

const { t } = useI18n();

const onUpload = ({ file }) => {
  if (!file) return;

  const validation = validateInboxAvatarFile(file);
  if (!validation.valid) {
    useAlert(
      t(
        `INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.AVATAR_UPLOAD.${validation.errorKey}`
      )
    );
    return;
  }

  emit('logoSelected', file);
};
</script>

<template>
  <div class="flex shrink-0 flex-col items-center sm:items-start">
    <Avatar
      :src="logoPreview"
      :name="name || 'Website'"
      :size="56"
      rounded-full
      allow-upload
      @upload="onUpload"
      @delete="emit('remove')"
    />
  </div>
</template>
